import { useQuery } from '@tanstack/react-query';
import api from '../../../config/http';

export const useAfiliadoProfileQuery = (codigoAfiliado: number | null) => {
  return useQuery({
    queryKey: ['getAfiliado', codigoAfiliado],
    enabled: !!codigoAfiliado,
    retry: false,
    queryFn: () =>
      api
        .get<any>('afiliado/getAfiliado', {
          params: { codigoAfiliado },
        })
        .then((res) => res.data),
  });
};
